const ExpandTransition = () => import(/* webpackChunkName: "common-components-chunk" */ './ExpandTransition.vue')

export { ExpandTransition }
